module.exports = __webpack_public_path__ + "101565a3e4b87e9b81d731016cb8affa.svg";